// config/seoConfig.js
const BASE_URL = "https://www.techexplore.cn";
const SITE_NAME = "专利工具箱 - TechExplore";

export const seoConfig = {
  home: {
    path: "/",
    title: "首页",
    description:
      "欢迎访问我们的网站，提供专利附图标记添加、自检、AI专利撰写、思维导图、三维模型Solidworks预览、专利图片处理、技术交底书标引等工具",
    keywords: "AI专利,AI专利撰写,效率工具,专利工具",
    priority: 1.0,
    changefreq: "daily",
  },
  aiwrite: {
    path: "/aiwrite",
    title: "AI专利助手",
    description:
      "AI帮你完成专利技术交底书、专利说明书、背景技术等撰写，解放双手，提升生产力",
    keywords: "AI写作,智能写作,内容生成,专利撰写",
    priority: 0.9,
    changefreq: "weekly",
  },
  write: {
    path: "/write",
    title: "附图标号",
    description:
      "网站能够帮助用户在专利申请文件中添加/删除附图标号，并且还能生成发明内容",
    keywords: "专利附图,附图标记,发明内容生成",
    priority: 0.9,
    changefreq: "weekly",
  },
  xmind: {
    path: "/xmind",
    title: "思维导图",
    description: "在线思维导图工具，帮助您整理思路和规划项目",
    keywords: "思维导图,脑图,Xmind,在线思维导图",
    priority: 0.9,
    changefreq: "weekly",
  },
  draw: {
    path: "/draw",
    title: "在线绘图",
    description: "专业的visio在线绘图工具，支持流程图、架构图等",
    keywords: "在线绘图,流程图,架构图,visio",
    priority: 0.8,
    changefreq: "weekly",
  },
  figures: {
    path: "/figures",
    title: "转线条图",
    description: "可以将彩色图，三维模型截图等图片转化为线稿图/线框图",
    keywords: "转CAD线条图,线稿图,线框图",
    priority: 0.8,
    changefreq: "weekly",
  },
  check: {
    path: "/check",
    title: "专利自检",
    description:
      "专利自检工具，用户录入专利申请文件/权利要求书/说明书，网页在线检查专利形式内容",
    keywords: "专利自检,形式问题,专利错别字,专利补正",
    priority: 0.8,
    changefreq: "weekly",
  },
  todolist: {
    path: "/todolist",
    title: "待办清单",
    description: "在线待办事项管理工具，帮助您高效管理日常任务",
    keywords: "待办事项,任务管理,Todo List",
    priority: 0.8,
    changefreq: "weekly",
  },
  extract_word_photo: {
    path: "/extract_word_photo",
    title: "图片提取",
    description: "用户上传技术交底书等word文本，网页自动提取文件中的图片",
    keywords: "word图片提取,技术交底书,图片提取",
    priority: 0.8,
    changefreq: "weekly",
  },
  ainav: {
    path: "/ainav",
    title: "AI导航",
    description: "AI工具导航大全，收录最新最全的AI工具",
    keywords: "AI导航,AI工具,人工智能",
    priority: 0.7,
    changefreq: "weekly",
  },
  searchnav: {
    path: "/searchnav",
    title: "专利搜索导航",
    description: "聚合搜索导航，一站式搜索入口",
    keywords: "专利数据库导航,聚合搜索,搜索引擎",
    priority: 0.7,
    changefreq: "weekly",
  },
  threeD: {
    path: "/ThreeD",
    title: "3D建模",
    description: "在线3D建模工具，创建精美3D模型",
    keywords: "3D建模,三维模型,在线3D",
    priority: 0.7,
    changefreq: "weekly",
  },
  threeDViewer: {
    path: "/threeDViewer",
    title: "3D模型查看器",
    description: "在线3D模型查看器，支持多种3D格式，支持Solidworks模型预览",
    keywords: "3D查看器,模型预览,3D展示,Solidworks",
    priority: 0.7,
    changefreq: "weekly",
  },
  intelligent_attachment: {
    path: "/intelligent_attachment",
    title: "智能标引",
    description: "用户上传技术交底书，网站为技术交底书中的图片添加零部件名称",
    keywords: "智能标引,智能附图,超级附图",
    priority: 0.7,
    changefreq: "weekly",
  },
  book: {
    path: "/book",
    title: "审查指南",
    description: "在线查看审查指南资料，提供详细的审查标准和流程",
    keywords: "专利审查指南,专利操作规程",
    priority: 0.6,
    changefreq: "monthly",
  },
  severance_pay: {
    path: "/severance_pay",
    title: "离职补偿",
    description: "在线离职补偿金计算",
    keywords: "离职补偿,经济补偿金,N+1计算",
    priority: 0.6,
    changefreq: "monthly",
  },
};

// 默认 SEO 配置
export const defaultSEO = {
  siteName: SITE_NAME,
  baseUrl: BASE_URL,
  defaultTitle: "专利工具箱",
  defaultDescription:
    "专业的专利辅助工具平台，提供AI专利撰写、附图标记、专利自检等服务",
  defaultKeywords: "专利工具,AI专利,效率工具",
  ogImage: `${BASE_URL}/og-image.png`,
  twitterHandle: "@techexplore",
};

// 根据页面名称获取 SEO 配置
export function getSEOByPage(pageName) {
  const config = seoConfig[pageName] || {};
  return {
    title: config.title
      ? `${config.title} | ${defaultSEO.siteName}`
      : defaultSEO.defaultTitle,
    description: config.description || defaultSEO.defaultDescription,
    keywords: config.keywords || defaultSEO.defaultKeywords,
    canonicalUrl: config.path
      ? `${defaultSEO.baseUrl}${config.path}`
      : defaultSEO.baseUrl,
    ogImage: defaultSEO.ogImage,
    siteName: defaultSEO.siteName,
    ...config,
  };
}

// 根据路径获取 SEO 配置
export function getSEOByPath(path) {
  const entry = Object.entries(seoConfig).find(
    ([_, config]) => config.path === path
  );
  return entry ? getSEOByPage(entry[0]) : getSEOByPage("home");
}
